import { useDispatch } from 'react-redux';
import { Banner } from '@optimus-web/core';
import { OptimusPlainLink } from '@mews-commander/ui';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { navigateInBaseModal } from '../../../app/actions/common';
import { useBookingEngineUpsellingUrl } from '../../utils/useBookingEngineUpsellingUrl';

export const BookingEngineLinkUpselling: React.FC = () => {
    const dispatch = useDispatch();
    const url = useBookingEngineUpsellingUrl();

    if (!url) {
        return null;
    }

    const onClick = () => dispatch(navigateInBaseModal(url));

    return (
        <Banner
            variant="info"
            primaryText={
                <>
                    <LocalizedText textKey={TextKey.AvailabilityBlockBookingEngineLinkUpsellingText} />
                    <br />
                    <OptimusPlainLink
                        href={url}
                        onClick={onClick}
                        dataTestId={DataTestId.AvailabilityBlockBookingEngineUpselling}
                        inherit
                    >
                        <LocalizedText textKey={TextKey.AvailabilityBlockBookingEngineLinkUpsellingLinkText} />
                    </OptimusPlainLink>
                </>
            }
        />
    );
};
